import * as t from 'io-ts';

import {RAsyncStatus} from '../../appTypes';
import {RNavigationBlockerId} from '../app/appPanelHelpers';
import {RPanelCancelTokenId} from '../panelCancelTokenId';
import {PanelTypesEnum, RAnalyticsPanelId, RPanelStateBase} from '../panelStateBase';
import {RAnalyticsPanelDetailsStateDirty} from './details/analyticsPanelDetailsState';
import {RAnalyticsPanelExportsStateDirty} from './exports/analyticsPanelExportsState';
import {RAnalyticsPanelFiltersStateDirty} from './filters/analyticsPanelFiltersState';
import {RAnalyticsParameters} from './parameters/analyticsParameters';
import {RAnalyticsPanelReportStateDirty} from './report/analyticsPanelReportState';
import {RAnalyticsPanelViewsStateDirty} from './views/analyticsPanelViewsState';

export const RAnalyticsPanelStateDirty = t.intersection([
  RPanelStateBase,
  t.type({
    id: RAnalyticsPanelId,
    type: t.literal(PanelTypesEnum.ANALYTICS),
    parameters: RAnalyticsParameters,
    status: RAsyncStatus,
    cancelTokenId: RPanelCancelTokenId,

    // ignore navigation blocking Ids
    unsavedViewNavigationBlockerId: RNavigationBlockerId,

    // Filters sub-state.
    filters: RAnalyticsPanelFiltersStateDirty,

    // Report sub-state.
    report: RAnalyticsPanelReportStateDirty,

    // Views sub-state.
    views: RAnalyticsPanelViewsStateDirty,

    // Metrics details sub-state.
    details: RAnalyticsPanelDetailsStateDirty,

    // Exports sub-state.
    exports: RAnalyticsPanelExportsStateDirty,
  }),
]);

/*
 * Types.
 */

export interface AnalyticsPanelState extends Readonly<t.TypeOf<typeof RAnalyticsPanelStateDirty>> {}

export const RAnalyticsPanelState = t.clean<AnalyticsPanelState>(RAnalyticsPanelStateDirty as any);
